import Home from './Home'
import Board from './Board'
import Group from './Group'
import store from '@/store'
import { yyyymmdd_ddmmyyy } from '@/utils'
import axios from 'axios'
import { API_ENDPOINT_BASE } from '@/constans'
import swal from 'sweetalert2'
import { LOADING, DEPARTURE, ASSIGNMENTS } from '@/store/mutations'

export default [
  {
    path: '/salidas',
    name: 'departures',
    component: Home,
    beforeEnter: (to, from, next) => {
      store.commit(LOADING, true)

      axios
        .get(API_ENDPOINT_BASE + '/assignments')
        .then(({ data }) => {
          store.commit(ASSIGNMENTS, data)
        })
        .catch(error => {
          swal({ html: error.response.data.msg, type: 'error' })
          store.commit(ASSIGNMENTS, [])
        })

      axios
        .get(API_ENDPOINT_BASE + '/departures')
        .then(({ data }) => {
          store.commit(
            DEPARTURE,
            data.map(departure => ({
              ...departure,
              bus: JSON.parse(departure.bus),
              date_departure: yyyymmdd_ddmmyyy(departure.date_departure),
              rates: [],
              prices: []
            }))
          )
          next(e => {
            console.log(e)
          })
        })
        .catch(error => {
          swal({ html: error.response.data.msg, type: 'error' })
          store.commit(DEPARTURE, [])
        })
        .finally(() => store.commit(LOADING, false))
    },
    children: []
  },
  {
    path: '/grupo/:id',
    name: 'group',
    component: Group
  },
  {
    path: '/salidas/:id/:tab?',
    name: 'departure',
    component: Board,
    beforeEnter: ({ params }, from, next) => {
      store.dispatch('DEPARTURE', params.id).then(next)
        .catch(() => {
          next({ name: 'departures' })
        })
    }
  },
  {
    path: '/reservar/:reservation_id/:id/:tab?',
    name: 'book',
    component: Board,
    beforeEnter ({ params }, from, next) {
      if (params.reservation_id && params.id) {
        store
          .dispatch('booking/OPEN', params.reservation_id)
          .then(() => {
            next()
          })
          .catch(() => {
            next({ name: 'departures' })
          })
      }
    }
  }
]
